import { LEARNING_LAB_ROUTES, MAIN_ROUTES, SERVICES_ROUTES } from "@/constants/routes";
import { LabDataType } from "../components/labDataType";

export const ENTERPRISE_DATA: LabDataType[] = [
  {
    duration: 2,
    labSku: "Fortinet SD-WAN",
    id: 61,
    product_id: 12,
    category_id: 6,
    price: 275,
  },
  {
    duration: 5,
    labSku: "Cisco SD-WAN LAB",
    id: 63,
    product_id: 13,
    category_id: 6,
    price: 300,
    url: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.LEARNING_LABS}${LEARNING_LAB_ROUTES.CISCO_SD_WAN}`,
  },
  {
    duration: 5,
    labSku: "Cisco enterprise Networking Lab",
    id: 68,
    product_id: 17,
    category_id: 7,
    price: 350,
  },
  {
    duration: 3,
    labSku: "Aruba Silver Peak SD-WAN LAB",
    id: 62,
    product_id: 14,
    category_id: 6,
    price: 350,
  },
  {
    duration: 3,
    labSku: "Versa SD-WAN Lab",
    id: 65,
    product_id: 15,
    category_id: 6,
    price: 350,
  },
  {
    duration: 3,
    labSku: "Velo Cloud SD-WAN Lab",
    id: 64,
    product_id: 16,
    category_id: 6,
    price: 350,
  },
  {
    duration: 3,
    labSku: "Cisco Software Defined Access",
    id: 57,
    product_id: 6,
    category_id: 3,
    price: 375,
    url: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.LEARNING_LABS}${LEARNING_LAB_ROUTES.CISCO_SDA}`,
  },
  {
    duration: 30,
    labSku: "CCIE Enterprise Lab",
    id: 66,
    product_id: 18,
    category_id: 7,
    price: 450,
  },
  {
    duration: 5,
    labSku: "Cisco Wireless Lab with AX APS",
    price: 575,
  },
  {
    duration: 30,
    labSku: "CCIE Enterprise with DNA Center",
    id: 67,
    product_id: 19,
    category_id: 7,
    price: 1500,
  },
  {
    duration: 30,
    labSku: "Cisco Software Defined Access",
    id: 58,
    product_id: 7,
    category_id: 3,
    price: 2820,
    url: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.LEARNING_LABS}${LEARNING_LAB_ROUTES.CISCO_SDA}`,
  },
];
